import {
    START_LOADING,
    CREATE_SECTION_HEALTHCARE,
    GET_SECTIONS_HEALTHCARE,
    END_LOADING,
    UPDATE_SECTION_HEALTHCARE,
    DELETE_SECTION_REQUEST_HEALTHCARE,
    DELETE_SECTION_SUCCESS_HEALTHCARE,
    DELETE_SECTION_FAILURE_HEALTHCARE,
    GET_HEALTHCARE_VENDORS,
} from '../constants/actionTypes.js';

const initialState = {
    sectionsHealthcare: [],
    healthcareVendors: [],
    isLoading: false,
    error: null,
};

export const healthcareSectionReducer = (state = initialState, action) => {
    switch (action.type) {
        case START_LOADING:
            return { ...state, isLoading: true };
        case CREATE_SECTION_HEALTHCARE:
            return { ...state, sectionsHealthcare: [...state.sectionsHealthcare, action.payload], isLoading: false };
        case GET_SECTIONS_HEALTHCARE:
            return { ...state, sectionsHealthcare: action.payload, isLoading: false };
        case UPDATE_SECTION_HEALTHCARE:
            return {
                ...state,
                sectionsHealthcare: state.sectionsHealthcare.map((section) =>
                    section._id === action.payload._id ? action.payload : section
                ),
                isLoading: false,
            };
        case DELETE_SECTION_REQUEST_HEALTHCARE:
            return { ...state, isLoading: true };
        case DELETE_SECTION_SUCCESS_HEALTHCARE:
            return {
                ...state,
                sectionsHealthcare: state.sectionsHealthcare.filter((section) => section._id !== action.payload),
                isLoading: false,
            };
        case DELETE_SECTION_FAILURE_HEALTHCARE:
            return { ...state, error: action.payload, isLoading: false };
        case GET_HEALTHCARE_VENDORS:
            return { ...state, healthcareVendors: action.payload, isLoading: false };
        case END_LOADING:
            return { ...state, isLoading: false };
        default:
            return state;
    }
};






